// @ts-nocheck
import { ContactUsTopicsFormFieldValues } from "@store/Framework/Store/Greif/Components/ContactUsTopicsForm/ContactUsTopicsFormState";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = Array<keyof ContactUsTopicsFormFieldValues>;
type HandlerType = Handler<Parameter>;

export const DispatchSaveDraftFieldValues: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/ContactUsTopicsForm/SaveDraftFieldValues",
        keys: props.parameter,
    });
};

export const chain = [DispatchSaveDraftFieldValues];

const saveDraftFieldValues = createHandlerChainRunnerOptionalParameter(chain, [] as Parameter, "SaveDraftFieldValues");

export default saveDraftFieldValues;
